export default "__VITE_ASSET__CIUmyDx$__"